import axios from 'axios';

// Axios client oluşturuyoruz
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor olmayan basic bir axios instance (refresh token için)
const axiosBasic = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // (401 Unauthorized)
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');

      if (refreshToken) {
        try {
          // Interceptor olmayan basic axios ile istek yapıyoruz
          const response = await axiosBasic.post('/refresh', { refreshToken });
          
          if (response.status === 200) {
            const newToken = response.data.accessToken;
            localStorage.setItem('accessToken', newToken);
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return axiosClient(originalRequest);
          } else {
            // Başarısız ise login sayfasına yönlendir
            console.error('Token yenileme başarısız:', response.status);
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            window.location.href = '/login';
            return Promise.reject(error);
          }
        } catch (err) {
          // Hata durumunda login sayfasına yönlendir
          console.error('Token yenileme hatası:', err);
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
          return Promise.reject(error);
        }
      } else {
        // RefreshToken yoksa login sayfasına yönlendir
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
